// Exemplos REAIS dos formatos que o sistema produz (círculo, quadrado,
// retângulo, coração). As imagens em /examples/formats/*-mono.png são PNG
// cinza+alfa gerados pelo nosso próprio motor (scripts/make_landing_examples.py):
// o fio é o canal alfa, por isso o browser pode pintá-lo com QUALQUER cor
// (CSS mask) — é assim que funciona o seletor de cor da landing.

export const FORMAT_EXAMPLES = [
  {
    id: "circulo-retrato",
    shape: "circle",
    label: "Círculo",
    motif: "Retrato a partir de fotografia",
    frame: "wood",
    src: "/examples/formats/circulo-retrato-mono.png",
  },
  {
    id: "circulo-mandala",
    shape: "circle",
    label: "Círculo",
    motif: "Mandala geométrica",
    frame: "black",
    src: "/examples/formats/circulo-mandala-mono.png",
  },
  {
    id: "quadrado-retrato",
    shape: "square",
    label: "Quadrado",
    motif: "Retrato a partir de fotografia",
    frame: "black",
    src: "/examples/formats/quadrado-retrato-mono.png",
  },
  {
    id: "quadrado-estrela",
    shape: "square",
    label: "Quadrado",
    motif: "Estrela paramétrica",
    frame: "wood",
    src: "/examples/formats/quadrado-estrela-mono.png",
  },
  {
    id: "retangulo-onda",
    shape: "rectangle",
    label: "Retângulo",
    motif: "Curva de fio (curve-stitch)",
    frame: "black",
    src: "/examples/formats/retangulo-onda-mono.png",
  },
  {
    id: "coracao-mandala",
    shape: "heart",
    label: "Coração",
    motif: "Fio contínuo",
    frame: "wood",
    src: "/examples/formats/coracao-mandala-mono.png",
  },
];

// Cores de fio reais do catálogo (backend/materials.py). `board` é o fundo
// sugerido para cada cor (fio claro pede fundo escuro e vice-versa).
export const THREAD_COLORS = [
  { id: "black", label: "Preto", hex: "#101010", board: "white" },
  { id: "white", label: "Branco", hex: "#F5F5F0", board: "black" },
  { id: "kroma", label: "Laranja", hex: "#FF3B00", board: "white" },
  { id: "red", label: "Vermelho", hex: "#C81E1E", board: "linen" },
  { id: "navy", label: "Azul profundo", hex: "#16233F", board: "linen" },
  { id: "teal", label: "Turquesa", hex: "#178C9C", board: "white" },
  { id: "gold", label: "Dourado", hex: "#C9A227", board: "black" },
  { id: "magenta", label: "Magenta", hex: "#EC008C", board: "black" },
];

export const BOARDS = [
  { id: "white", label: "Branco", hex: "#F7F7F4" },
  { id: "black", label: "Preto", hex: "#0C0C0E" },
  { id: "linen", label: "Linho cru", hex: "#E7DFD1" },
  { id: "wood", label: "Madeira", hex: "#C89B6A" },
];

export const boardHex = (id) => (BOARDS.find((b) => b.id === id) || BOARDS[0]).hex;
